import { Search as SearchIcon, SearchOff as SearchOffIcon } from "@mui/icons-material";
import { Chip } from "@mui/material";

interface SearchableChipProps {
  isSearchable: boolean;
}

export const SearchableChip = ({ isSearchable }: SearchableChipProps) => {
  return (
    <Chip
      size="small"
      icon={isSearchable ? <SearchIcon fontSize="small" /> : <SearchOffIcon fontSize="small" />}
      label={isSearchable ? "Searchable" : "Hidden"}
      color={isSearchable ? "info" : "default"}
    />
  );
};
